import { render } from "./MngOrgnization.vue?vue&type=template&id=3ca3f77e&scoped=true&ts=true"
import script from "./MngOrgnization.vue?vue&type=script&lang=ts"
export * from "./MngOrgnization.vue?vue&type=script&lang=ts"

import "./MngOrgnization.vue?vue&type=style&index=0&id=3ca3f77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca3f77e"]])

export default __exports__